import { useEffect, useRef } from "react";

export function useDelayableCallback<T>(
	e: T,
	callback: (e: T) => void,
	predicate?: (e: T) => boolean,
	timeout = 2000,
): void {
	const previousTimeout = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		const clearPreviousTimeout = (id: NodeJS.Timeout | null) => {
			if (id !== null) {
				clearTimeout(id);
			}
		};
		if (predicate?.(e) ?? true) {
			clearPreviousTimeout(previousTimeout.current);
			previousTimeout.current = setTimeout(() => {
				callback(e);
			}, timeout);
		} else {
			clearPreviousTimeout(previousTimeout.current);
		}
	}, [callback, e, predicate, timeout]);
}
